import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import {AppBar, Modal} from '@timmons-group/shared-react-components';
import Box from '@mui/material/Box';

import { ACLS, LOGO_URL } from 'constants';
import { AUTH_STATES } from '@timmons-group/shared-react-components/constants';
import { useAuth } from '@timmons-group/shared-react-components/hooks';

const NAV_ITEMS = [
  { title: 'Home', href: '/' },
  {
    title: 'Communities',
    href: '/communities',
    permission: ACLS.VIEW_COMMUNITIES,
  },
  { title: 'Plans', href: '/pam/plans', permission: ACLS.VIEW_PLANS },
  {
    title: 'Explorer',
    href: '/explorer/hvra',
    permission: ACLS.VIEW_EXPLORER,
  },
]

const Layout = () => {
  const [buildVersion, setbuildVersion] = useState({});
  // The useProvideAuth in useAuth.js contains the exposed properties and methods
  const { login, logout, refresh, authState } = useAuth();

  useEffect(() => {
    // I need to fetch buildInfo.json to get the build number
    const fetchBuild = async () => {
      try {
        const response = await fetch('/buildInfo.json');
        const data = await response.json();
        setbuildVersion(data);
      } catch (error) {
        console.log('Error fetching buildInfo.json', error);
      }
    };
    fetchBuild();
  }, []);

  return (
    <>
      <Box
        component="p"
        className={buildVersion ? 'version' : 'hidden'}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
      >
        v{buildVersion ? `${buildVersion.frontendVersion}.${buildVersion.packageVersion}`: ''}
      </Box>
      <AppBar
        navLinks={NAV_ITEMS}
        user={authState?.user}
        onLogin={() => login()}
        onLogout={logout}
        logoUrl={LOGO_URL}
      />
      <Outlet />
      <Modal open={authState?.state === AUTH_STATES.TOKEN_STALE} okLabel="Continue" cancelLabel="Log Out" onCancel={logout} onOk={refresh}>
        <Box component="p" className="stale-token">It looks like your session is idle and your access token has expired. Click continue to keep using the system. </Box>
      </Modal>
      <Modal open={authState?.state === AUTH_STATES.REFRESHING_TOKEN} hideOk={true} hideCancel={true}>
        <Box component="p" className="stale-token">Refreshing your session...</Box>
      </Modal>
    </>
  );
};

export default Layout;
